import { observer } from 'mobx-react-lite'
import { CarrierVisitAllocationRulesViewStore } from '../../stores/allocation-rules/carrier-visit-allocation-rules.view-store'
import { GlobalAllocationRulesViewStore } from '../../stores/allocation-rules/global-allocation-rules.view-store'
import { CarrierVisitOverviewViewStore } from '../../stores/carrier-visit-overview.viewstore'
import { HousekeepingPlanAccumulatorViewStore } from '../../stores/housekeeping-plan-accumulator.view-store'
import { BerthViewStore } from '../../stores/nodes/berth.view-store'
import { FlexibleBlockViewStore } from '../../stores/nodes/flexible-block.view-store'
import { LayoutObjectViewStore } from '../../stores/nodes/layout-object.view-store'
import { RailTrackViewStore } from '../../stores/nodes/rail-track.view-store'
import { RoadNetworkViewStore } from '../../stores/nodes/road-network.view-store'
import { YardBlockViewStore } from '../../stores/nodes/yard-block.view-store'
import { YardViewStore } from '../../stores/yard.view-store'
import { YardSetupHeader } from '../molecules/YardSetupHeader'
import { YardViewHeader } from '../molecules/YardViewHeader'

interface Props {
  globalAllocationRulesViewStore: GlobalAllocationRulesViewStore
  carrierVisitAllocationRulesViewStore: CarrierVisitAllocationRulesViewStore
  yardBlockViewStore: YardBlockViewStore
  flexibleBlockViewStore: FlexibleBlockViewStore
  layoutObjectViewStore: LayoutObjectViewStore
  berthViewStore: BerthViewStore
  railTrackViewStore: RailTrackViewStore
  roadNetworkViewStore: RoadNetworkViewStore
  yardViewStore: YardViewStore
  carrierVisitOverviewViewStore: CarrierVisitOverviewViewStore
  housekeepingPlanAccumulatorViewStore: HousekeepingPlanAccumulatorViewStore
}
export const YardHeader = observer((props: Props) => {
  return props.yardViewStore.isViewMode ? (
    <YardViewHeader {...props} />
  ) : (
    <YardSetupHeader {...props} />
  )
})
